import { useRef } from "react";
import { SquarebtnProps } from "../common/types";
import { useRippleEffect } from "../../hooks/useRippleEffect";
import { Squarebtn } from "../common/squareBtnProps";
import React from "react";
import GsapMagnetic from "./GsapMagnetic";

function SquareBtn({
  children,
  $strength,
  $btnText,
  ...props
}: SquarebtnProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useRippleEffect(buttonRef);

  return (
    <GsapMagnetic $maxTranslation={props.$magneticMaxTranslation}>
      <Squarebtn
        ref={buttonRef}
        {...props}
        $border={props.$border}
        $hoverBackground={props.$hoverBackground}
        $hoverColor={props.$hoverColor}
        $color={props.$color}
        $position={props.$position}
        $top={props.$top}
        $right={props.$right}
        $zIndex={props.$zIndex}
        id={props.id}
        $transition={props.$transition}
      >
        {children ? children : <div className="txtPresent"> {$btnText} </div>}
      </Squarebtn>
    </GsapMagnetic>
  );
}

export default React.memo(SquareBtn);
